import { Component, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'layout-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {

    constructor() {}

}


// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/shared/layout/sidebar.component.ts